import { FC, useCallback } from "react";
import BeginnerIcon from "../../../../icons/beginner";
import IntermediateIcon from "../../../../icons/intermediate";
import AdvancedIcon from "../../../../icons/advanced";
import { TargetAudience } from "../../../../types";

interface LevelIconProps {
  level: TargetAudience;
}

const LevelIcon: FC<LevelIconProps> = ({ level }) => {
  const Icon = useCallback(() => {
    switch (level) {
      case "beginner":
        return <BeginnerIcon />;
      case "intermediate":
        return <IntermediateIcon />;
      case "advanced":
        return <AdvancedIcon />;
      default:
        return <></>;
    }
  }, [level]);

  return <Icon />;
};

export default LevelIcon;
